import {
    take,
    takeLatest,
    put,
    select
} from 'redux-saga/effects';

import { ACTIONS } from '../actions/actionTypes';
import { push } from 'react-router-redux';
import * as interaction from '../views/InteractionViews/interactions';
import PlaySound from '../sounds/playSound';
import errorCatcher from '../utils/errorCatcher';

function * PROPOSE_SESSION () {
    yield takeLatest(ACTIONS.PROPOSE_SESSION, function * (action) {
        try {
            yield put({
                type: ACTIONS.OPEN_SIMPLE_MODAL,
                payload: action.payload
            });
        } catch (error) {
            error.message = 'Error in PROPOSE_SESSION (gameSaga): ' + error.message;
            errorCatcher(error);
            yield put(push('/'));
        }
    });
}

function * START_SESSION () {
    yield takeLatest(ACTIONS.START_SESSION, function * (action) {
        try {
            const questions = yield select(state => state.questionReducer.questions);
            yield put({type: ACTIONS.SET_SESSION_MISSION, payload: action.payload});
            yield put({
                type: ACTIONS.DISPATCH_INTERACTION,
                payload: interaction.missionStart({
                    userMission: action.payload,
                    numberOfQuestions: questions.length
                })
            });
            yield take(ACTIONS.INTERACTION_ACTION);
            yield put({type: ACTIONS.ON_SESSION});
        } catch (error) {
            error.message = 'Error in START_SESSION (gameSaga): ' + error.message;
            errorCatcher(error);
            yield put(push('/'));
        }
    });
}

function * ON_SESSION () {
    yield takeLatest(ACTIONS.ON_SESSION, function * (action) {
        try {
            const userMission = yield select(state => state.sessionReducer.mission);
            let viewType = 'paper'; // Case of no mission
            if (userMission) {
                viewType = userMission.mission.subType;
            }
            yield put({
                type: ACTIONS.SET_QUESTION_VIEW,
                payload: viewType
            });
            yield put(push('/questions'));
        } catch (error) {
            error.message = 'Error in ON_SESSION (gameSaga): ' + error.message;
            errorCatcher(error);
            yield put(push('/'));
        }
    });
}

function * FINISH_SESSION () {
    yield takeLatest(ACTIONS.FINISH_SESSION, function * (action) {
        try {
            const userMission = yield select(state => state.sessionReducer.mission);
            yield put({type: ACTIONS.STOP_TIMER});
            yield put({type: ACTIONS.SET_QUESTION_LOADING, payload: true});
            const {session} = action.payload;
            let finishedMission = {session, userMission};
            yield put({type: ACTIONS.SAVE_SESSION, payload: finishedMission});
            yield take(ACTIONS.SET_SESSION);
            const sessionResult = yield select(state => state.sessionReducer.session);
            // Set the nextMissions without this one
            yield put({type: ACTIONS.USER_SET_WHATSNEXT, payload: sessionResult.whatsNext});
            yield put({type: ACTIONS.SET_MISSIONS, payload: sessionResult.whatsNext.nextMissions});

            finishedMission.session = sessionResult;
            yield put({type: ACTIONS.DISPATCH_INTERACTION, payload: interaction.missionResult(finishedMission)});
            yield take(ACTIONS.INTERACTION_ACTION);
            const {whatsNext} = sessionResult;
            if (whatsNext.newLevel) {
                yield put({type: ACTIONS.LEVEL_UP, payload: whatsNext});
            } else if (whatsNext.repeatLevel) {
                yield put({type: ACTIONS.REPEAT_LEVEL, payload: whatsNext});
            } else {
                yield put(push('/'));
            }
        } catch (error) {
    error.message = 'Error in FINISH_SESSION (gameSaga): ' + error.message;
errorCatcher(error);
yield put(push('/'));
}
});
}

function * DISPATCH_INTERACTION () {
    yield takeLatest(ACTIONS.DISPATCH_INTERACTION, function * (action) {
        yield put({type: ACTIONS.SET_INTERACTION, payload: action.payload});
        yield put(push('/interaction'));
    });
}

function * DISPATCH_CURIOSITY () {
    yield takeLatest(ACTIONS.DISPATCH_CURIOSITY, function * (action) {
        yield put({type: ACTIONS.SET_CURIOSITY_LOADING, payload: true});
        yield put({type: ACTIONS.GET_CURIOSITY, payload: action.payload});
        yield put(push('/curiosities'));
    });
}

function * LEVEL_UP () {
    yield takeLatest(ACTIONS.LEVEL_UP, function * (action) {
        try {
            PlaySound('levelUp');
            const user = yield select(state => state.user.user);
            switch (user.data.level.title.toUpperCase()) {
            case 'MONITOR':
                yield put({type: ACTIONS.DISPATCH_INTERACTION, payload: interaction.levelUp(user.data.level)});
                yield take(ACTIONS.INTERACTION_ACTION);
                yield put(push('/courseSelection/' + 'monitor'));
                break;
            case 'GRADUADO':
                yield put({type: ACTIONS.DISPATCH_INTERACTION, payload: interaction.levelUp(user.data.level)});
                yield take(ACTIONS.INTERACTION_ACTION);
                yield put(push('/courseSelection/' + 'graduation'));
                break;
            case 'MESTRE':
                yield put({type: ACTIONS.DISPATCH_INTERACTION, payload: interaction.levelUp(user.data.level)});
                yield take(ACTIONS.INTERACTION_ACTION);
                yield put(push('/courseSelection/' + 'master'));
                break;
            case 'DOUTOR':
                yield put({type: ACTIONS.DISPATCH_INTERACTION, payload: interaction.levelUp(user.data.level)});
                yield take(ACTIONS.INTERACTION_ACTION);
                yield put(push('/courseSelection/' + 'doctor'));
                break;
            default:
                // Show email
                yield put({type: ACTIONS.DISPATCH_INTERACTION, payload: interaction.levelUp(user.data.level)});
                yield take(ACTIONS.INTERACTION_ACTION);
                yield put(push('/'));
                break;
            }
        } catch (error) {
            error.message = 'Error in LEVEL_UP (gameSaga): ' + error.message;
            errorCatcher(error);
            yield put(push('/'));
        }
    });
}

function * REPEAT_LEVEL () {
    yield takeLatest(ACTIONS.REPEAT_LEVEL, function * (action) {
        try {
            PlaySound('repeat');
            const user = yield select(state => state.user.user);
            if (user.data.level.title.toUpperCase() !== 'ENEM') {
                yield put({type: ACTIONS.DISPATCH_INTERACTION, payload: interaction.repeatLevel(user.data.level)});
                yield take(ACTIONS.INTERACTION_ACTION);
            }
            let dateNow = new Date(Date.now() + (5 * 60 * 1000));
            let reproved = {
                situation: true,
                time: dateNow
            };
            window.localStorage.setItem('reproved', JSON.stringify(reproved));
            yield put(push('/'));
        } catch (error) {
            error.message = 'Error in REPEAT_LEVEL (gameSaga): ' + error.message;
            errorCatcher(error);
            yield put(push('/'));
        }
    });
}

export {
    PROPOSE_SESSION,
    START_SESSION,
    ON_SESSION,
    FINISH_SESSION,
    LEVEL_UP,
    DISPATCH_INTERACTION,
    DISPATCH_CURIOSITY,
    REPEAT_LEVEL
};



// WEBPACK FOOTER //
// ./src/sagas/gameSaga.js